module.exports = __webpack_public_path__ + "static/media/image5.de629a5f.jpg";